export class SetNewPasswordModel {
    public Email:string;
    public OTP:number;
    public UserPassword:string;
    public UserConfirmPassword:string;
}
